<template lang="">
  <BreadCrumb :items="breadcrumbItems" />
  <main id="main">
    <NoticeDtlForm :noticeSeq = noticeSeq />
  </main>
</template>

<script>
import NoticeDtlForm from '@/components/customerService/NoticeDtlForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
  data() {
    return {
      breadcrumbItems: [
        { href: "/", text: "홈", isHome: true },
        { href: "#", text: "고객센터" },
      ],
    };
  },

  props: {
    noticeSeq: {
      type: String,
      required: true
    }
  },

  components: {
    NoticeDtlForm,
    BreadCrumb
  }

}
</script>
<style lang="">

</style>